export class UserProfileType {
  public static readonly User: string = "User";
  public static readonly SuperUser: string = "SuperUser";
  public static readonly Administrator: string = "Administrator";

  public static readonly AllowedUserProfileRoles: string[] = [
    this.User,
    this.SuperUser,
    this.Administrator
  ];
}
